var api = {};

/* alert()/prompt() block the calling thread until the user responds. Called
   synchronously inside an XHR onreadystatechange handler (as all of these are),
   Chrome attributes the whole popup duration to that handler and logs
   "[Violation] 'readystatechange' handler took XXXms" for as long as the dialog
   sat open. Route every dialog through a FIFO queue instead: the handler
   returns immediately, dialogs still appear one-at-a-time in order (the
   ban-appeal prompt must not be skipped by an alert queued ahead of it). */
api.dialogQueue = Promise.resolve();

api.queueDialog = function(fn) {
  var run = api.dialogQueue.then(fn);
  api.dialogQueue = run.then(function() {}, function() {});
  return run;
};

api.alert = function(message) {
  api.queueDialog(function() { alert(message); });
};

api.prompt = function(message, defaultValue) {
  return api.queueDialog(function() { return prompt(message, defaultValue); });
};

/* Yes/no dialog, same queue as alert/prompt. Resolves true on OK, false on
   Cancel. Use this for confirmations — api.prompt for a yes/no question has
   no "no" button (native prompt only cancels by TYPING, and a typed reply
   proceeds with a garbage answer). */
api.confirm = function(message) {
  return api.queueDialog(function() { return confirm(message); });
};

/* Response callbacks (which may themselves alert — account/bans/board admin
   flows do) run one task later so that work they do happens outside the XHR
   onreadystatechange handler as well. XHR callbacks were always async; this
   only adds one tick, order is preserved. */
api.invokeCallback = function(callback, args) {
  setTimeout(function() { callback.apply(null, args); }, 0);
};

api.mobile = window.innerWidth < 812;

api.padDateField = function(value) {

  if (value < 10) {
    value = '0' + value;
  }

  return value;

};

api.formatDateToDisplay = function(d, local) {

  var day = api.padDateField(d[local ? 'getDate' : 'getUTCDate']());

  var weekDays = [ 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat' ];

  var month = api.padDateField(d[local ? 'getMonth' : 'getUTCMonth']() + 1);

  var year = d[local ? 'getFullYear' : 'getUTCFullYear']();

  var weekDay = weekDays[d[local ? 'getDay' : 'getUTCDay']()];

  var hour = api.padDateField(d[local ? 'getHours' : 'getUTCHours']());

  var minute = api.padDateField(d[local ? 'getMinutes' : 'getUTCMinutes']());

  var second = api.padDateField(d.getUTCSeconds());

  var toReturn = month + '/' + day + '/' + year;

  return toReturn + ' (' + weekDay + ') ' + hour + ':' + minute + ':' + second;

};

api.htmlReplaceTable = {
  '<' : '&lt;',
  '>' : '&gt;',
  '\"' : '&quot;',
  '\'' : '&apos;'
};

api.removeIndicator = function(className, thread) {

  var elements = (thread || document).getElementsByClassName(className);

  if (!elements.length) {
    return;
  }

  elements[0].nextSibling.remove();
  elements[0].remove();

};

api.addIndicator = function(className, title, thread) {

  var spanId = (thread || document).getElementsByClassName('spanId')[0];

  if (!spanId) {
    //spanId = (thread || document).getElementsByClassName('labelCreated')[0];
    spanId = (thread || document).getElementsByClassName('extraMenuButton')[0];
  }

  if (className == "lockIndicator") {
	var indicator = document.createElement('img');
    indicator.src= "/.static/images/locked.gif";
    indicator.alt = "locked";
    indicator.className = className;
    indicator.title = title;
  } else if (className == "cyclicIndicator") {
	var indicator = document.createElement('img');
	indicator.src= "/.static/images/cyclic.png";
    indicator.alt = "cyclic";
    indicator.className = className;
    indicator.title = title;
  } else if (className == "pinIndicator") {
	var indicator = document.createElement('img');
	indicator.src= "/.static/images/sticky.gif";
    indicator.alt = "sticky";
    indicator.className = className;
    indicator.title = title;
  } else if (className == "bumpLockIndicator") {
	var indicator = document.createElement('span');
	indicator.textContent = "[AUTOSÄGE]"
	indicator.className = className;
	indicator.title = title;
  } else {
	var indicator = document.createElement('span');
	indicator.className = className;
    indicator.title = title;
  }

  spanId.parentNode.insertBefore(indicator, spanId.nextSibling);
  spanId.parentNode.insertBefore(document.createTextNode(' '),
      spanId.nextSibling);

};

api.resetIndicators = function(data, thread) {

  api.removeIndicator('lockIndicator', thread);
  api.removeIndicator('pinIndicator', thread);
  api.removeIndicator('cyclicIndicator', thread);
  api.removeIndicator('archiveIndicator', thread);
  api.removeIndicator('bumpLockIndicator', thread);


  api.addIndicator('cyclicIndicator', 'Cyclical Thread', thread);
  api.addIndicator('pinIndicator', 'Sticky', thread);
  api.addIndicator('lockIndicator', 'Locked', thread);
  api.addIndicator('archiveIndicator', 'Archived', thread);
  api.addIndicator('bumpLockIndicator', 'Bumplocked', thread);


  if (!data.locked) {
    api.removeIndicator('lockIndicator', thread);
  }

  if (!data.pinned) {
    api.removeIndicator('pinIndicator', thread);
  }

  if (!data.cyclic) {
    api.removeIndicator('cyclicIndicator', thread);
  }

  if (!data.archived) {
    api.removeIndicator('archiveIndicator', thread);
  }

  if (!data.autoSage) {
    api.removeIndicator('bumpLockIndicator', thread);
  }

};

api.addEnterEvent = function(element, onclick) {

  element.addEventListener('keydown', function(event) {

    if (event.key === 'Enter') {
      onclick();
      event.preventDefault();
    }

  });

};

api.convertButton = function(button, onclick, inputs) {

  if (typeof (button) === 'string') {
    button = document.getElementById(button);
  }

  button.type = 'button';
  button.onclick = onclick;

  if (!inputs) {
    return;
  }

  inputs = document.getElementsByClassName(inputs);

  for (var i = 0; i < inputs.length; i++) {
    api.addEnterEvent(inputs[i], onclick);
  }

};

api.getCookies = function() {

  var parsedCookies = {};

  var cookies = document.cookie.split(';');

  for (var i = 0; i < cookies.length; i++) {

    var cookie = cookies[i];

    var parts = cookie.split('=');
    parsedCookies[parts.shift().trim()] = decodeURI(parts.join('='));

  }

  return parsedCookies;

};

api.handleConnectionResponse = function(xhr, callback, silent) {

  var response;

  try {
    response = JSON.parse(xhr.responseText);
  } catch (error) {
    // An expired/invalid session makes the engine answer with a 302 to
    // /login.html. The XHR follows it and lands on the login HTML page, which
    // is not JSON — so instead of a useless parse error, send the user back to
    // log in (covers both the followed-redirect case via responseURL and the
    // rare non-followed 302).
    if (xhr.status === 302 ||
        (xhr.responseURL && xhr.responseURL.indexOf('/login.html') > -1)) {
      window.location.href = '/login.html';
    } else if (!silent) {
      api.alert('Error in parsing response.');
    }
    return;
  }

  if (response.status === 'error') {

    if (!silent) {
      api.alert(response.data);
    }

  } else if (response.status === 'hashBan') {

    var desc = '';

    var bans = response.data;

    for (var i = 0; i < bans.length; i++) {
      var ban = bans[i];

      if (i) {
        desc += '\n';
      }

      desc += 'File ' + ban.file + ' is banned from '
          + (ban.boardUri ? '/' + ban.boardUri + '/' : 'all boards.');

      if (ban.reason) {
        desc += ' Reason: ' + ban.reason + '.';
      }

    }

    api.alert(desc);
  } else if (response.status === 'bypassable') {

    postCommon.displayBlockBypassPrompt(function() {
      api.alert('You may now post');
    });

  } else if (response.status === 'maintenance') {

    if (!silent) {
      api.alert('The site is undergoing maintenance and all of its functionalities are temporarily disabled.');
    }

  } else if (response.status === 'banned') {

    var message;

    if (response.data.range) {
      message = 'Your ip range ' + response.data.range
          + ' has been banned from ' + response.data.board + '.';
    } else if (response.data.asn) {
      message = 'Your ASN ' + response.data.asn + ' has been banned from '
          + response.data.board + '.';
    } else if (response.data.warning) {
      message = 'You have been warned on ' + response.data.board + '.';
    } else {
      message = 'You are banned from ' + response.data.board + '.';
    }

    if (response.data.reason) {
      message += '\nReason: "' + response.data.reason.replace('&gt;', '>') + '".';
    }

    if (response.data.warning) {
      api.alert(message);
      return;
    }

    if (response.data.expiration) {

      message += '\nThis ban will expire at '
          + new Date(response.data.expiration).toString() + '.';

    } else {
      message += '\nThis ban will not expire.'
    }

    message += '\nYour ban id: ' + response.data.banId + '.';

    if (!response.data.appealled) {
      message += '\nYou may appeal this ban.';

      api.prompt(message, 'Write your appeal').then(function(appeal) {

        if (appeal && appeal !== 'Write your appeal') {

          api.formApiRequest('appealBan', {
            appeal : appeal,
            banId : response.data.banId
          }, function appealed(status, data) {

            if (status !== 'ok') {
              api.alert(data);
            } else {
              api.alert('Ban appealed');
            }

          });

        }

      });

    } else {
      api.alert(message);
    }

  } else {
    api.invokeCallback(callback, [response.status, response.data]);
  }

};

api.formApiRequest = function(page, parameters, callback, silent, getParameters, showFailed) {

  var silent;

  if (page.indexOf('addon.js') < 0) {
    page += '.js?json=1';
  } else {
    page += '&json=1';
  }

  getParameters = getParameters || {};

  for ( var parameter in getParameters) {
    page += '&' + parameter + '='
        + encodeURIComponent(getParameters[parameter]);
  }

  var xhr = new XMLHttpRequest();

  if ('withCredentials' in xhr) {
    xhr.open('POST', '/' + page, true);
  } else if (typeof XDomainRequest != 'undefined') {

    xhr = new XDomainRequest();
    xhr.open('POST', '/' + page);
  } else {
    api.alert('Update your browser or turn off javascript.');

    return;
  }

  if (callback.hasOwnProperty('progress')) {
    xhr.upload.onprogress = callback.progress;
  }

  xhr.onreadystatechange = function connectionStateChanged() {

    if (xhr.readyState !== 4) {
      return;
    }

    if (parameters.captcha) {
      captchaUtils.reloadCaptcha();
    }

    if (callback.hasOwnProperty('stop')) {
      callback.stop();
    }

    if (xhr.status != 200) {

      // BUTTONDISABLE
      if (typeof thread !== "undefined" && typeof thread.replyButton !== "undefined") {
        thread.replyButton.disabled = false;
        qr.setQRReplyEnabled(true);
      }
      if (xhr.status === 403) {
        api.invokeCallback(callback, ["fail", 'Could not post. You may need to solve once the cloudflare.com challenge at https://kohlchan.net/unlocked.html']);
        return;
      } else if (!silent) {
        api.alert('Connection failed.');
      }

      if (showFailed) {
        api.invokeCallback(callback, ['fail']);
        return;
      }

      return;
    }

    api.handleConnectionResponse(xhr, callback, silent);

  };

  var form = new FormData();

  for ( var entry in parameters) {

    if (!parameters[entry] && typeof (parameters[entry] !== 'number')) {
      continue;
    }

    if (entry !== 'files') {

      if (Array.isArray(parameters[entry])) {

        var values = parameters[entry];

        for (var i = 0; i < values.length; i++) {
          form.append(entry, values[i]);
        }

      } else {
        form.append(entry, parameters[entry]);
      }

    } else {

      var files = parameters.files;

      for (var i = 0; i < files.length; i++) {

        var file = files[i];

        if (file.sha256) {
          form.append('fileSha256', file.sha256);
          form.append('fileMime', file.mime);
          form.append('fileSpoiler', file.spoiler || '');
          form.append('fileName', file.name);
        }

        if (file.content) {
          form.append('files', file.content, file.name);
        }

      }

    }

  }

  xhr.send(form);

};

api.localRequest = function(address, callback) {

  var xhr = new XMLHttpRequest();

  if ('withCredentials' in xhr) {
    xhr.open('GET', address, true);
  } else if (typeof XDomainRequest != 'undefined') {

    xhr = new XDomainRequest();
    xhr.open('GET', address);
  } else {
    api.alert('Update your browser or turn off javascript.');
    return;
  }

  xhr.onreadystatechange = function connectionStateChanged() {

    if (xhr.readyState == 4) {

      if (callback.hasOwnProperty('stop')) {
        callback.stop();
      }

      if (xhr.status == 404) {
        api.invokeCallback(callback, ['404']);
      } else if (xhr.status != 200) {
        api.invokeCallback(callback, ['Connection failed']);
      } else {
        api.invokeCallback(callback, [null, xhr.responseText]);
      }

    }
  };

  xhr.send();

};

api.setCookie = function(name, value, expires) {
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
};

api.isModDomain = function() {
  return location.hostname.startsWith('mod') || location.hostname === 'localhost';
};

if (document.cookie.indexOf("svg_support=") < 0) {
    api.setCookie("svg_support", "true", "");
}
